/** @format */

import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';

const SKELETON_ROW_COUNT = 5;

const ShopOrdersSkeletonRow = () => (
  <div className="shop-orders__row shop-orders__skeleton-row">
    <div className="shop-orders__col shop-orders__col--number">
      <Skeleton variant="text" width="80%" height={24} />
    </div>
    <div className="shop-orders__col shop-orders__col--date">
      <Skeleton variant="text" width="70%" height={24} />
    </div>
    <div className="shop-orders__col shop-orders__col--price">
      <Skeleton variant="text" width="60%" height={24} />
    </div>
    <div className="shop-orders__col shop-orders__col--status">
      <Skeleton variant="rectangular" width={88} height={28} />
    </div>
    <div className="shop-orders__col shop-orders__col--action">
      <Skeleton variant="text" width="70%" height={24} />
    </div>
  </div>
);

export default function ShopOrdersSkeleton() {
  const { t } = useTranslation();

  return (
    <div className="shop-orders__content shop-orders__content--skeleton">
      <div className="shop-orders__table">
        <div className="shop-orders__row shop-orders__row--header">
          <div className="shop-orders__col shop-orders__col--number">{t('widget.shopNumber')}</div>
          <div className="shop-orders__col shop-orders__col--date">{t('widget.shopDate')}</div>
          <div className="shop-orders__col shop-orders__col--price">{t('widget.shopPrice')}</div>
          <div className="shop-orders__col shop-orders__col--status">{t('common.status')}</div>
          <div className="shop-orders__col shop-orders__col--action">{t('widget.shopAction')}</div>
        </div>
        <div className="shop-orders__body">
          {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
            <ShopOrdersSkeletonRow key={index} />
          ))}
        </div>
      </div>
      <div className="shop-orders__link">
        <Skeleton variant="text" width={140} height={28} />
      </div>
    </div>
  );
}
